<template>
  <div class="ly_modal_container" :style="{width: '840px', zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">{{getNewsTypeText(this.newsType)}} 받는사람 ({{logTypeText}})</h1>
    </div>
    <div class="ly_modal_content" style="min-height:537px">
      <template v-if="detailData">
        <h4 class="section_title">
          <span class="ico"></span>
          {{sendDateTitle}} :
          <span class="highlight">{{sendDateText}}</span>
        </h4>
        <ScrollTable ref="table" :sourceList="detailData.data">
          <template #header>
            <caption>
              <span class="blind">{{logTypeText}} 받는 사람</span>
            </caption>
            <colgroup>
              <col width="5%" />
              <col width="12%" />
              <col width="20%" />
              <col />
              <col width="15%" />
              <col width="15%" />
            </colgroup>

            <thead class="table_list_head">
              <tr>
                <CheckAllHeader :selectedList="selectedList" :sourceList="selectableList" />
                <th>이름</th>
                <th>TID</th>
                <th>그룹</th>
                <th v-if="isRepeatNews">확인여부</th>
                <th>스피커알림</th>
                <th>상세이력</th>
              </tr>
            </thead>
          </template>
          <template #row="{ rowData }">
            <tr :class="highlight(rowData)">
              <td>
                <input
                  type="checkbox"
                  :value="rowData"
                  v-model="selectedList"
                  :disabled="!rowData.resendButtonEnable"
                />
              </td>
              <td>{{rowData.rcpName}}</td>
              <td>{{rowData.rcpNuguTid}}</td>
              <td>{{rowData.rcpGroup}}</td>
              <ConfirmTextColumn v-if="isRepeatNews" :value="rowData.rcpReadYn" />
              <PushStatusColumn displayType="RCP" :statusCode="rowData.pushStatus" />
              <td>
                <button
                  v-if="detailLinkUrl(rowData)"
                  type="button"
                  class="btn_function"
                  @click="$router.push(detailLinkUrl(rowData))"
                >보기</button>
                <span v-else>-</span>
              </td>
            </tr>
          </template>
        </ScrollTable>

        <div class="btn_area">
          <!-- <button type="button" class="btn_active" @click="resend">알림 재전송</button> -->
          <button type="button" class="btn_default" @click="close">닫기</button>
        </div>
      </template>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import newsMixin from "$views/News/_mixin";
import popupMixin from "$mixins/popup";
import RecipientList from "./RepeatRecipientList";

export default {
  extends: RecipientList,
  props: {
    newsId: [String, Number],
    newsType: String,
    logType: String,
    sendDate: String
  },
  mixins: [popupMixin, newsMixin],
  data() {
    return {
      detailData: null
    };
  },
  computed: {
    isRepeatNews() {
      return this.newsType === "REPEAT";
    },
    logTypeText() {
      switch (this.logType) {
        case "daily":
          return "일별";
        case "itemBy":
          return "건별";
        default:
          return "-";
      }
    },
    sendDateTitle() {
      switch (this.logType) {
        case "daily":
          return "전송날짜";
        case "itemBy":
          return "전송시간";
        default:
          return "-";
      }
    },
    sendDateText() {
      switch (this.logType) {
        case "daily":
          return this.$utils.dateText(this.sendDate);
        case "itemBy":
          return this.$utils.timeText(this.sendDate);
        default:
          return "-";
      }
    }
  },
  methods: {
    detailLinkUrl(rowData) {
      const url = `/news/recipient/${rowData.rcpId}/repeat_log_${this.logType.toLowerCase()}`;
      return url != this.$route.path ? url : null;
    },
    loadData() {
      this.$axios
        .get(
          `/admin/v2/news/repeat/${this.newsId}/logs/${this.logType}/${this.sendDate}/rcp/lists`
        )
        .then(({ data }) => (this.detailData = data));
    }
  },
  mounted() {}
};
</script>
